import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/gajewsky/code/smooth-ui/website/node_modules/smooth-doc/src/layouts/docs.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "system"
    }}><a parentName="h1" {...{
        "href": "#system",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`System`}</h1>
    <p>{`Smooth UI implements `}<a parentName="p" {...{
        "href": "https://www.smooth-code.com/open-source/xstyled/docs/system-props/"
      }}>{`xstyled system`}</a>{` in all components. It gives you real power to style your application in a declarative way.`}</p>
    <h2 {...{
      "id": "use-system-props"
    }}><a parentName="h2" {...{
        "href": "#use-system-props",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Use system props`}</h2>
    <p>{`System props gives you an opportunity to modify all styles directly from props.`}</p>
    <p>{`For example, you can easily change the `}<inlineCode parentName="p">{`backgroundColor`}</inlineCode>{` and the horizontal `}<inlineCode parentName="p">{`padding`}</inlineCode>{` of a `}<inlineCode parentName="p">{`Button`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live noInline",
        "live": true,
        "noInline": true
      }}>{`import React from 'react'
import { Button } from '@smooth-ui/core-sc'

function Example() {
  return (
    <Button px="2rem" backgroundColor="blue">
      Hello world
    </Button>
  )
}

render(<Example />)
`}</code></pre>
    <p>{`You can see all possibility offered by system properties on `}<a parentName="p" {...{
        "href": "https://www.smooth-code.com/open-source/xstyled/docs/system-props/"
      }}>{`xstyled documentation`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      